<ng-container *ngIf="summary$ | async as summary">
  <div class="progress-summary">
    <span>{{ summary.total | currency:'USD':'symbol-narrow':'1.0-0' }}</span>
    <ng-container *ngIf="(summary.goal && summary.goal !== 0) else raisedTemplate">
      raised of {{ summary.goal | currency:'USD':'symbol-narrow':'1.0-0' }}
    </ng-container>
    <ng-template #raisedTemplate> raised </ng-template>
  </div>
</ng-container>
<ng-container *ngIf="progress$ | async as progress">
  <div class="progress progress-mdb--paybee  progress--height">
    <div
      class="progress-bar bg-success progress-bar--paybee"
      role="progressbar"
      [ngStyle]="{'width.%': progress}"
      aria-valuenow="progress"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>
  </div>
</ng-container>

